import { get } from "@/axios";
const base = process.env.VUE_APP_API_ROOT;

function getPermissionShow(data) {
  return get(`${base}/shuian-home/order/hasPermission`,{permissionCode:data}).then(
    (res) => res.data?.data
  );
}
/**增加按钮权限获取数据*/
export async function getButtonShow(type) {
  const res = await getPermissionShow(type)
  return res
}


